// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.talents-carousel__header{padding-right:22px}`, "",{"version":3,"sources":["webpack://./src/react/containers/Vcard/components/TalentsSection/style.scss"],"names":[],"mappings":"AACI,0BACI,kBAAA","sourcesContent":[".talents-carousel {\n    &__header {\n        padding-right: 22px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
